import { render, staticRenderFns } from "./UserMasterItem.vue?vue&type=template&id=5063525a&scoped=true&"
import script from "./UserMasterItem.vue?vue&type=script&lang=js&"
export * from "./UserMasterItem.vue?vue&type=script&lang=js&"
import style0 from "./UserMasterItem.vue?vue&type=style&index=0&id=5063525a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5063525a",
  null
  
)

export default component.exports